import Swiper from 'swiper';
import 'swiper/css';

const coreCardsSlider = new Swiper('.core-service-intro__cards-slider .swiper', {
	autoHeight: true,
	slidesPerView: 1,
	spaceBetween: 20,
	breakpoints: {
		480: {
			slidesPerView: 1,
			spaceBetween: 40,
		},
		600: {
			slidesPerView: 1,
			spaceBetween: 40,
		},
		1024: {
			slidesPerView: 2,
			spaceBetween: 40,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 40,
		}
	}
});
